// extracted by css-extract-rspack-plugin
export default {"BaseCell":"date-renderer-module__BaseCell__vqO3Cb2"};